import { useTranslation } from 'react-i18next';
import { useWaWorkplaceStore } from 'src/api/wa/store/WaWorkplaceStore';
import { ButtonProps } from '../../common/button/Button';
import DetailsBar from './bar/DetailsBar';
import DetailsHeader from './header/DetailsHeader';
import { useEffect, useState } from 'react';
import RelatedDetails from './Related';
import Details from './details/Details';
import Button from 'src/ui/wards/common/button/Button';
import { useNavigate } from 'react-router-dom';
import InlineAlert from '../../common/inlineAlert/InlineAlert';
import useWaProductService from 'src/api/wa/service/WaProductService';

const S4_2_SiteDetails = () => {
  const { t } = useTranslation();
  const { selectedWorkplace: currentSite } = useWaWorkplaceStore();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showErrorCancelReservation, setShowErrorCancelReservation] = useState(false);
  const { fetchProducts, fetchProductMasterInfo } = useWaProductService();
  const navigate = useNavigate();
  const buttons: ButtonProps[] = [
    {
      title: t('wards.siteDetails.details'),
      key: t('wards.siteDetails.details'),
    },
    {
      title: t('wards.siteDetails.related'),
      key: t('wards.siteDetails.related'),
    },
  ];

  useEffect(() => {
    if (currentSite) {
      // Prefetch products for Status Bulk Change
      fetchProducts(currentSite);
      fetchProductMasterInfo(currentSite);
    }
  }, [fetchProducts, fetchProductMasterInfo, currentSite]);

  return (
    <div className="min-h-screen bg-gray-100 py-4">
      <DetailsHeader siteName={currentSite?.name ?? ''} />
      <div className="flex justify-start px-4">
        <Button title={t('wards.common.back')} onClick={() => navigate(-1)} />
      </div>
      {showErrorCancelReservation && <InlineAlert customStyles="text-center text-lg mb-4" />}
      <DetailsBar
        buttons={buttons}
        initialSelectedIndex={selectedIndex}
        indexChanged={(index) => setSelectedIndex(index)}
      />
      {selectedIndex === 0 && currentSite && (
        <Details onError={(hasError) => setShowErrorCancelReservation(hasError)} />
      )}
      {selectedIndex === 1 && <RelatedDetails />}
    </div>
  );
};

export default S4_2_SiteDetails;
